import { Button, Stack, styled } from '@mui/material';
import { Link } from 'react-router-dom';

import {
  colorTertiaryBaseStyle,
  colorTertiaryFocusStyle,
  colorTertiaryHoverStyle,
} from '../../styles/mui/components/shared';

type ToggleButtonProps = {
  'data-is-open': boolean;
};

export const ComposeLink = styled(Link)(() => ({
  '&:focus': {
    ...colorTertiaryFocusStyle,
  },
  '&:focus-visible': {
    boxShadow: 'none',
  },
  '&:hover': {
    ...colorTertiaryHoverStyle,
  },
  ...colorTertiaryBaseStyle,
  alignItems: 'center',
  borderRadius: 'var(--border-radius-medium)',
  boxShadow: 'var(--elevation-3)',
  display: 'flex',
  fontWeight: 'var(--font-weight-button-label)',
  gap: 'var(--spacing-small)',
  justifyContent: 'flex-start',
  marginTop: 'var(--spacing-small)',
  padding: 'var(--spacing-medium)',
}));

export const ToggleButton = styled(Button)<ToggleButtonProps>(props => ({
  '& > svg': {
    transform: props['data-is-open'] ? 'rotate(-45deg)' : 'rotate(0deg)',
    transition: 'transform var(--preference-transition-duration-normal)',
  },
  '&.Mui-focusVisible': {
    ...colorTertiaryFocusStyle,
  },
  '&.MuiButton-containedTertiary': {
    borderRadius: props['data-is-open']
      ? 'var(--border-radius-small)'
      : 'var(--border-radius-medium)',
    marginTop: 'var(--spacing-small)',
    minWidth: 'auto',
    padding: props['data-is-open']
      ? 'var(--spacing-small)'
      : 'var(--spacing-medium)',
    transition: 'all var(--preference-transition-duration-normal)',
  },
}));

export const Wrapper = styled(Stack)(() => ({
  '&:focus-visible': {
    boxShadow: 'none',
    outline: 'none',
  },
}));
